module.exports = __webpack_public_path__ + "img/beast_chrs.10ad0488.png";